import * as tslib_1 from "tslib";
import { Feature } from '../types';
export default function mapPropsToFeatures(props) {
  return Object.keys(Feature).reduce(function (acc, key) {
    var _a;

    return tslib_1.__assign({}, acc, (_a = {}, _a[key] = Boolean(props[key]), _a));
  }, {});
}